<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">动环设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="通道名称" prop="ChannelName">
                <el-input
                  v-model="data.ChannelName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警名称" prop="SignalName">
                <el-input
                  v-model="data.SignalName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="报警等级" prop="AlarmLevel">
                <el-select
                  v-model="data.AlarmLevel"
                  placeholder="请选择"
                  :disabled="!IsEdit"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in alarmLevelArr"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警状态" prop="AlarmStatus">
                <el-select
                  v-model="data.AlarmStatus"
                  placeholder="请选择"
                  :disabled="!IsEdit"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in alarmStatusArr"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="BeginTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.BeginTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="EndTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.EndTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "dynEnvironmentAlarmInfo",
  controller: "UI",
  action: "dynEnvironmentAlarmInfo",
  data() {
    return {
      data: {
        LATITUDE: "",
        LONGITUDE: "",
      },
      alarmLevelArr: [
        { value: 1, name: "一级告警" },
        { value: 2, name: "二级告警" },
        { value: 3, name: "三级告警" },
        { value: 4, name: "四级告警" },
      ],
      alarmStatusArr: [
        { value: 0, name: "未结束" },
        { value: 1, name: "已结束" },
      ],
      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,
      rules: {
        TRASHCODE: [
          { required: true, message: "请输入垃圾桶编号", trigger: "blur" },
        ],
        TRASHNAME: [
          { required: true, message: "请输入垃圾桶名称", trigger: "blur" },
        ],
        LONGITUDE: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        LATITUDE: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        BELONGAREA: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        TRASHTYPE: [
          { required: true, message: "请选择垃圾桶类型", trigger: "change" },
        ],
      },
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getRegionInfo();
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onGotLngLat(obj) {
      this.data.LATITUDE = obj.lat || 0;
      this.data.LONGITUDE = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.TranResourcesApi()
          .GetItemById({ Id: InfoId })
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: uuid,
          TRASHSTATUS: 0, //1 在线 0 离线
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
